import { createSlice } from '@reduxjs/toolkit';
import sliceNames from '../../constants/sliceNames';
import {
    SetClaimNumberFailedRegexAction,
    SetErrorMessageAction,
    SetLoadingModalFlagAction,
    SetZipCodeFailedRegexAction,
} from '../index';

export interface AppStateData {
    loadingModalFlag: boolean;
    errorMessage: string;
    claimNumberFailedRegex: boolean;
    zipCodeFailedRegex: boolean;
}

export interface UpdateAppStateData {
    loadingModalFlag?: boolean;
    errorMessage?: string;
    claimNumberFailedRegex?: boolean;
    zipCodeFailedRegex?: boolean;
}

export const initialAppState = {
    loadingModalFlag: false,
    errorMessage: '',
    claimNumberFailedRegex: false,
    zipCodeFailedRegex: false,
};

const appStateSlice = createSlice({
    name: sliceNames.appStateSlice,
    initialState: initialAppState,
    reducers: {
        setLoadingModalFlag: (state: AppStateData, action: SetLoadingModalFlagAction) => ({
            ...state,
            loadingModalFlag: action.payload,
        }),
        setErrorMessage: (state: AppStateData, action: SetErrorMessageAction) => ({
            ...state,
            errorMessage: action.payload,
        }),
        setClaimNumberFailedRegex: (state: AppStateData, action: SetClaimNumberFailedRegexAction) => ({
            ...state,
            claimNumberFailedRegex: action.payload,
        }),
        setZipCodeFailedRegex: (state: AppStateData, action: SetZipCodeFailedRegexAction) => ({
            ...state,
            zipCodeFailedRegex: action.payload,
        }),
        validateRegex: (state: AppStateData) => ({
            ...state,
            zipCodeFailedRegex: false,
            claimNumberFailedRegex: false,
        }),
    },
});

const { actions, reducer } = appStateSlice;

export const {
    setClaimNumberFailedRegex,
    setZipCodeFailedRegex,
    setLoadingModalFlag,
    setErrorMessage,
    validateRegex,
} = actions;
export default reducer;
